import angular, { ILogService, IOnChangesObject } from 'angular'
import { TiposDocEstadosStore } from 'src/_candidato/data/tiposStore'
import { IFilaCV } from 'src/model/candidato-api'

class CvStateInfoComponentCtrl {
  curr!: IFilaCV
  tipos!: TiposDocEstadosStore
  state!: string
  simple!: boolean

  _stateDesc: string

  constructor(private $log: ILogService) {}

  $onInit(): void {
    this.$log.info('[CvStateInfoComponentCtrl] onInit')
  }

  $onChanges(changes: IOnChangesObject) {
    this.$log.info('----> changes', changes)

    if (changes.state || changes.tipos) {
      this._stateDesc = this._estadoDesc()
    }
  }

  private _estadoDesc() {
    let t = this.tipos && this.tipos.estadosStore().data[this.curr.cv.estado]

    return (t && `${t.estado.texto_en} - ${t.estado.texto_es}`) || this.curr.cv.estado
  }

  get stateDesc() {
    // this.$log.info('[stateDesc]')
    return this._stateDesc
  }
}

angular.module('candidato').component('cvStateInfo', {
  bindings: {
    curr: '<',
    tipos: '<',
    state: '<',
    simple: '<',
  },
  controller: CvStateInfoComponentCtrl,
  // templateUrl: "cv-state-info.component.html",
  template: require('./cv-state-info.component.html'),
})
